import PageLayout from "../../../components/layout/page";
import { DataView } from "../../../components/table/table";
import { useApi } from "../../../helper/apiHook";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import { Button } from "reactstrap";
import { plus } from "../../../constant/icons";
import { useEffect } from "react";
import { AddUpdateLit } from "./addUpdate";
import { columns } from "./columns";
import ModalView from "../../../components/modal";
export const MediaLitApi = (paging?:boolean, dataLoad: any = {}) => {
  return { ...useApi("/mediaLitType",paging, undefined, dataLoad) };
};
export default function LITtype() {
  const api = MediaLitApi(true);
  useEffect(() => {
    api.mutate();
  }, []);
  const AddUpdate = useAddUpdate();
  return (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                name: "",
                description: "",
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <DataView
            columns={columns({
              api,
              openAddEditFrom: AddUpdate.openAddEditFrom,
            })}
            rows={api.data}
            updatePagination={api.updatePagination}
            currentPage={api.currentPage}
            rowCount={api.rowCount}
            limit={api.limit}
          />
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={
            AddUpdate.currentValue?.id ? "Edit Media Lit" : "Add Media Lit"
          }
          onModalDismiss={AddUpdate.closeAddEditFrom}
        >
          <AddUpdateLit
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}
